<app-header></app-header>
<div id="headerfake"></div>
<div id="leftmenufake"></div>
<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #leftSidenav mode="side" opened>
        <app-menu-left></app-menu-left>
    </mat-sidenav>
    <mat-sidenav class="sidenav-right" #rigthSidenav opened mode="side" position="end">
        <app-menu-right></app-menu-right>
    </mat-sidenav>    
    <mat-sidenav-content>
        <div *ngIf="becare.authenticated" class="main_content">
            <div style="padding: 0px">
                <app-legacy-content #legacycontent></app-legacy-content>
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
